import React from 'react';
import '../css/quote.css';

export default function Quote(props) {
  const { quote, character, image } = props.quoteInfo
  const { episode, title } = props.episodeInfo
  return (
    <div className="Quote">
      <div className="character-image">
        <img src={image} alt="character" id="image" />
      </div>
      <div className="character-quote">
        <h5 id="episode-info">{episode}: {title}</h5>
        <h2 id="quote">"{quote}"</h2>
        <h5 id="character">- {character}</h5>
      </div>
    </div>
  )
}

